<template>
    <div class="tag-info" :class="{ isDark: isPCDarkMode == 2 && isSearchMode }">
        <div class="collection-banner" v-if="collection && collection.banner_title">
            <div class="content">
                <div class="left">
                    <div class="titles">
                        {{ collection.banner_title }}
                    </div>
                    <div class="sub-titles">
                        {{ collection.banner_content }}
                    </div>
                </div>

                <div class="right">
                    <img :src="collection.banner_photo" alt="" height="372" />
                </div>
            </div>
        </div>

        <div class="collection-tool">
            <div class="bread-list">
                <span @click="setTempSelect('index')" class="with-hand">{{ isSearchMode ? $t("home") : $t("templates") }}</span>
                <template v-if="fromAllTags || isSearchMode">
                    <iconSymbol class="arrow-next" name="arrow-next" />
                    <span class="with-hand" @click="setTempSelect('tags')">{{ $t("all") }}</span>
                </template>
                <iconSymbol class="arrow-next" name="arrow-next" />
                <span>{{ $t("tag") }}: {{ collection.show_title }}</span>
            </div>
            <div class="selects">
                <i-select @on-change="changeFilter" v-model="filterSelect" class="selects" style="width: 120px">
                    <i-option v-for="item in items" :value="item.value" :key="item.value">{{ item.label }}</i-option>
                </i-select>
            </div>
        </div>
        <div class="collection-content">
            <tplWaterfall ref="waterfall" :works="works" type="center" />

            <div class="sc-add-spin sc-add-spin-en">
                <loading v-show="showAddSpin && !allWorkShowed" />
                <div class="txtC noworks-box" v-show="allWorkShowed">
                    <img src="@/home/assets/img/noworks.png" v-if="!works.length" alt="" />
                    <p style="font-size: 18px; font-weight: bold">{{ works.length ? $t("theEnd") : $t("noResult") }}</p>
                </div>
            </div>
        </div>

        <div class="recommond-collection" v-if="!isSearchMode">
            <div class="titles" v-if="lang !== 'en'">
                {{ $t("recommend") }}
            </div>
            <div class="titles" v-else>
                Recommend
                <span class="primary-color">Collections</span>
            </div>
            <div class="tags-list">
                <div class="tags-item" v-for="i in randomTags" :key="i.id" @click="setCollectionId(i.tag_id)">
                    <div class="inline-block position-relative">
                        <img :src="i.show_photo" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import tplCenter from "../../mixins/tplCenter";
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    import loading from "@/public/components/loading.vue";
    @Component({
        components: {
            loading,
        },
    })
    export default class tagInfo extends Mixins(tplCenter) {
        value = "";
        elementId = ".store-box";
        get items() {
            return [
                {
                    label: this.$t("trending"),
                    value: "PV",
                },
                {
                    label: this.$t("recent"),
                    value: "TIME",
                },
            ];
        }
        setTempSelect(data) {
            if (this.isSearchMode) {
                if (data === "index") {
                    (<any>window).$qt.jsCallBackToHomePage();
                    return;
                }
                this.$store.commit("toAlbumAll");
            } else {
                this.$store.commit("setState", {
                    type: "templateSelect",
                    data,
                });
            }
        }
        collection: any = {};
        tagName = "";
        get tagId() {
            return this.$store.state.tagId;
        }
        get tagList() {
            return this.$store.state.tagList;
        }
        get isSearchMode() {
            return this.$store.state.isSearchMode;
        }
        get randomTags() {
            if (!this.tagList.length) return [];
            let arr = [];
            for (let i = 0; i < 4; i++) {
                let doing = true;
                while (doing) {
                    const index = Math.floor(Math.random() * this.tagList.length);
                    if (!~arr.findIndex((item) => item.tag_id === this.tagList[index].tag_id) && this.tagList[index].tag_id !== this.tagId) {
                        arr.push(this.tagList[index]);
                        doing = false;
                    }
                }
            }
            return arr;
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        //是否显示底部loading动画
        showAddSpin = false;
        //所有作品显示完毕
        allWorkShowed = false;
        offset = 0;
        doRequest() {
            return new Promise((resolve, reject) => {
                let params = Object.assign(
                    {
                        user_id: this.userInfo ? this.userInfo.user_id : "",
                        token: this.userInfo ? this.userInfo.token : "",
                    },
                    {
                        offset: this.offset,
                        count: 30,
                        order: this.filterSelect, // TIME | PV | LIKE
                        sort: "DESC", // DESC | ASC
                        classId: 0,
                        price: 1, // 1全部 2免费 3付费 4会员免费
                        lang: this.lang,
                        tag: this.tagName,
                    }
                );

                this.$edApi
                    .getPublish(params)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
        doneReplaceWork = false;
        replaceWorks() {
            this.allWorkShowed = false;
            this.showAddSpin = true;
            this.doneReplaceWork = false;
            document.querySelector(this.elementId).scrollTop = 0;
            this.clearWaterfall();
            this.doRequest()
                .then((data: any) => {
                    this.clearWaterfall();
                    this.showAddSpin = false;
                    if (!data || data.length == 0) {
                        if (this.works.length == 0) {
                            this.allWorkShowed = true;
                        }
                        this.doneReplaceWork = true;
                        return;
                    }
                    this.offset += data.length;
                    this.updateWaterfall(
                        {
                            works: data,
                            noCache: null,
                            callback: () => {
                                if (data.length < 30) {
                                    //小于30个说明搜索结果已全部显示
                                    this.allWorkShowed = true;
                                }
                                this.doneReplaceWork = true;
                            },
                        },
                        true
                    );
                })
                .catch((err) => {});
        }
        addWorks() {
            //显示底部loading动画
            this.showAddSpin = true;
            this.count = 20;
            this.doRequest().then((data: any) => {
                if (data.length == 0) {
                    this.allWorkShowed = true;
                    this.showAddSpin = false;
                    this.isAdding = false;
                    return;
                }
                this.showAddSpin = false;
                this.offset += data.length;
                this.updateWaterfall({
                    works: data,
                    noCache: null,
                    callback: () => {
                        if (data.length < 20) {
                            //小于20个说明已全部显示
                            this.allWorkShowed = true;
                        }
                        this.isAdding = false;
                    },
                });
            });
        }

        scrollToAdd() {
            let targetDom = document.querySelector(this.elementId) as HTMLDivElement;
            if (this.isAdding) return;
            if (!this.doneReplaceWork) return;
            var scrollTop = targetDom.scrollTop;
            var recommond = document.querySelector(".recommond-collection")?.clientHeight;
            if (targetDom.scrollHeight - (scrollTop + targetDom.offsetHeight + (this.isSearchMode ? 0 : recommond)) < 30) {
                if (this.allWorkShowed) return;
                console.log("scroll add");
                this.isAdding = true;
                this.addWorks();
            }
        }
        scrollGetData() {
            //处理滚动到底部后继续加载图片
            let targetDom = document.querySelector(this.elementId) as HTMLDivElement;
            targetDom.addEventListener("scroll", this.scrollToAdd);
        }
        fetchTagInfo() {
            return this.$edApi
                .getSpecialTagsInfo({
                    lang: this.lang,
                    tag_id: this.tagId,
                })
                .then(({ collection, tag }) => {
                    this.collection = collection || {};
                    this.tagName = tag.name;
                });
        }
        mounted() {
            if (this.isSearchMode) {
                this.elementId = ".tags-box";
            }
            this.fetchTagInfo().then(() => {
                this.replaceWorks();
                this.scrollGetData();
            });
            this.$bus.$on("updateWorkIds2", (payload) => {
                let { id, type } = payload;
                for (let i = 0; i < this.works.length; i++) {
                    if (this.works[i].id == id) {
                        switch (type) {
                            case "like": {
                                this.works[i].like = this.works[i].like - 0 + 1;
                                break;
                            }
                            case "dislike": {
                                this.works[i].like -= 1;
                                break;
                            }
                            case "collect": {
                                this.works[i].collect = this.works[i].collect - 0 + 1;
                                break;
                            }
                            case "discollect": {
                                this.works[i].collect -= 1;
                                break;
                            }
                        }
                    }
                }
            });
        }
        @Watch("lang")
        langChange() {
            this.offset = 0;
            this.fetchTagInfo().then(() => {
                this.replaceWorks();
            });
        }
        beforeDestroy() {
            let targetDom = document.querySelector(this.elementId) as HTMLDivElement;
            targetDom.removeEventListener("scroll", this.scrollToAdd);
            this.$bus.$off("updateWorkIds2");
        }
        filterSelect = "PV";
        changeFilter() {
            this.offset = 0;
            this.replaceWorks();
        }
        get fromAllTags() {
            return this.$store.state.fromAllTags;
        }
        setCollectionId(data: number) {
            console.log(data);
            this.$store.commit("setState", {
                type: "templateSelect",
                data: "tagInfo",
            });
            this.$store.commit("setState", {
                type: "tagId",
                data,
            });
            this.$store.commit("setState", {
                type: "fromAllTags",
                data: false,
            });
        }
    }
</script>
<style lang="less">
    .tag-info {
        .primary-color {
            color: #017fff;
        }

        .collection-banner {
            padding: 0 15px;

            background: linear-gradient(268.44deg, #f8e6ff 0%, #dae7f6 97.53%);
            .content {
                padding: 15px 0;
                max-width: 1432px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                box-sizing: content-box;
                padding: 15px 23px 15px 15px;
                .left {
                    max-width: 950px;
                    flex: 1;
                    .titles {
                        font-weight: bold;
                        font-size: 48px;
                        line-height: 72px;
                        color: #000000;
                    }
                    .sub-titles {
                        line-height: 28px;
                        font-size: 20px;
                        color: #333333;
                        margin-top: 3px;
                    }
                }
                .right {
                    align-self: center;
                }
                @media screen and (max-width: 1432px) {
                    justify-content: center;
                    .left {
                        text-align: center;
                        .titles {
                            font-size: 32px;
                            line-height: 50px;
                            padding-top: 26px;
                        }
                        .sub-titles {
                            line-height: 26px;
                            font-size: 18px;
                            margin-top: 36px;
                            padding-bottom: 36px;
                        }
                    }
                    .right {
                        display: none;
                    }
                }
            }
        }
        .tag-banner {
            background: linear-gradient(268.44deg, #f8e6ff 0%, #dae7f6 97.53%);
            .titles {
                font-weight: bold;
                font-size: 48px;
                line-height: 72px;
                padding-top: 56px;
                text-align: center;
                color: #000000;
            }
            .sub-titles {
                font-size: 20px;
                line-height: 28px;
                text-align: center;
                margin-top: 3px;
                color: #333333;
            }
            .input-box {
                margin-left: auto;
                margin-right: auto;
            }
        }
        .input-wrap {
            padding-top: 42px;
            padding-bottom: 84px;
        }
        .input-box {
            border: 3px solid #000000;
            box-shadow: 0px 25px 49px rgba(8, 37, 111, 0.1);
            border-radius: 16px;
            display: flex;
            background: #fff;
            height: 88px;

            justify-content: space-between;
            align-items: center;
            max-width: 950px;

            input {
                font-size: 24px;
                height: 100%;
                outline: none;
                border: 0;
                flex: 1;
                margin-left: 36px;
                &::placeholder {
                    color: rgba(0, 0, 0, 0.4);
                }
            }
            .box-end {
                padding-left: 24px;
                padding-right: 24px;
                border-left: 1px solid #000;
            }
            @media screen and (max-width: 768px) {
                margin: 0px 15px;
                margin-top: 30px;
                height: 68px;

                input {
                    font-size: 16px;
                    margin-left: 16px;
                }
            }
        }
        .collection-tool {
            max-width: 1432px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;

            padding: 40px 23px 32px 15px;
            box-sizing: content-box;
            .ivu-select-selected-value,
            .ivu-select-item {
                font-size: 14px !important;
            }
            .bread-list {
                display: flex;
                align-items: center;
                .arrow-next {
                    width: 20px;
                    height: 20px;
                    color: var(--fontSearchTinyColor);
                }
                span {
                    font-size: 16px;
                    line-height: 28px;
                    height: 28px;
                    display: block;
                    padding: 0 4px;
                    border-radius: 4px;
                    &:not(:last-child) {
                        color: var(--fontSearchTinyColor);
                        &:hover {
                            color: var(--fontSearchColor);
                            background: var(--breadBgColor);
                        }
                    }
                    &:last-child {
                        color: var(--fontSearchColor);
                    }
                }
            }
        }
        .collection-content {
            max-width: 1432px;
            margin: 0 auto;
            padding: 0px 23px 0px 15px;
            box-sizing: content-box;
            .noworks-box {
                margin-top: 36px;
                color: #000;
            }
        }
        /deep/ .noworks {
            padding-bottom: 40px;
        }
        .mo-waterfall--grid-sizer {
            width: 23.743016759776536%;
        }
        .mo-work {
            width: 23.743016759776536%;
        }
        .mo-waterfall--gutter-sizer {
            width: 1.675977653631285%;
        }
        @media screen and (max-width: 2560px) {
            .mo-waterfall--grid-sizer {
                width: 23.743016759776536%;
            }
            .mo-work {
                width: 23.743016759776536%;
            }
            .mo-waterfall--gutter-sizer {
                width: 1.675977653631285%;
            }
        }
        @media screen and (max-width: 1920px) {
            .mo-waterfall--grid-sizer {
                width: 23.743016759776536%;
            }
            .mo-work {
                width: 23.743016759776536%;
            }
            .mo-waterfall--gutter-sizer {
                width: 1.675977653631285%;
            }
        }

        @media screen and (max-width: 1366px) {
            .mo-waterfall--grid-sizer {
                width: 31.835205992509363%;
            }
            .mo-work {
                width: 31.835205992509363%;
            }
            .mo-waterfall--gutter-sizer {
                width: 2.247191011235955%;
            }
        }

        @media screen and (max-width: 1280px) {
            .mo-waterfall--grid-sizer {
                width: 31.835205992509363%;
            }
            .mo-work {
                width: 31.835205992509363%;
            }
            .mo-waterfall--gutter-sizer {
                width: 2.247191011235955%;
            }
        }

        @media screen and (max-width: 1000px) {
            .mo-waterfall--grid-sizer {
                width: 48.295454545454547%;
            }
            .mo-work {
                width: 48.295454545454547%;
            }
            .mo-waterfall--gutter-sizer {
                width: 3.409090909090906%;
            }
        }

        @media screen and (max-width: 768px) {
            .mo-waterfall--grid-sizer {
                width: 100%;
            }
            .mo-work {
                width: 100%;
            }
            .mo-waterfall--gutter-sizer {
                width: 0%;
            }
        }
        &.isDark {
            .mo-waterfall {
                color: var(--fontTemplateTitleColor);
                /deep/.mo-work {
                    .mo-work--number-area {
                        span {
                            color: var(--fontTemplateDescTitleColor);
                        }

                        .mo-work--numbers {
                            .mo-ex--icon {
                                svg {
                                    fill: var(--iconTemplateColor);
                                }
                            }

                            > div {
                                svg {
                                    fill: var(--iconTemplateColor);
                                    stroke: var(--iconTemplateColor);
                                }
                            }
                        }
                    }
                }
            }
            .selects {
                .ivu-select {
                    .ivu-select-selection {
                        border-color: #ffffff14;
                        background: #222427;
                        color: #fff;
                    }
                    .ivu-icon {
                        color: #dadadf;
                    }
                    .ivu-select-dropdown {
                        background: #2a2c2e;

                        .ivu-select-item {
                            padding: 7px 10px;
                            color: #fff;
                            margin: 0 6px;
                            border-radius: 6px;
                            &:hover {
                                color: #e6e6e6;
                                background: #ffffff14;
                            }
                            &.ivu-select-item-selected {
                                color: #017fff;
                            }
                        }
                    }
                }
            }
        }
    }
    .recommond-collection {
        .titles {
            font-weight: bold;
            font-size: 44px;
            line-height: 55px;
            text-align: center;
            margin-bottom: 36px;
            color: #000;
        }
        max-width: 1432px;
        margin: 0 auto;
        padding: 24px 23px 72px 15px;
        box-sizing: content-box;
    }
</style>
<i18n>
{
  "zh": {
    "theEnd": "到底了",
    "noResult": "未搜索到",
    "trending": "趋势",
    "recent": "最近",
    "templates": "模板社区",
    "all": "所有类别",
    "recommend": "推荐类别",
    "home": "返回首页",
    "tag": "标签"
  },
  "en": {
    "theEnd": "Bottom",
    "noResult": "No Results",
    "trending": "Trending",
    "recent": "Recent",
    "templates": "Templates Community",
    "all": "All Collections",
    "recommend": "Recommend Collections",
    "home": "Home",
    "tag": "tag"
  },
  "de": {
    "theEnd": "Boden",
    "noResult": "Keine Ergebnisse",
    "trending": "Tendenz",
    "recent": "Zuletzt",
    "templates": "Schablonen Gemeinschaft",
    "all": "Alle Sammlungen",
    "recommend": "Empfohlene Kategorie",
    "home": "Start",
    "tag": "Schild"
  },
  "fr": {
    "theEnd": "Bas",
    "noResult": "pas de résultat",
    "trending": "Tendance",
    "recent": "Récent",
    "templates": "Communauté des Modèles",
    "all": "Toutes les Collections",
    "recommend": "Catégorie recommandée",
    "home": "Accueil",
    "tag": "Étiqueter"
  },
  "es": {
    "theEnd": "Final",
    "noResult": "No hay resultados",
    "trending": "Tendencias",
    "recent": "Recientes",
    "templates": "Comunidad de Plantillas",
    "all": "Todas las Colecciones",
    "recommend": "Categoría recomendada",
    "home": "Pantalla de Inicio",
    "tag": "Etiqueta"
  },
  "jp": {
    "theEnd": "最後です",
    "noResult": "検索結果なし",
    "trending": "人気",
    "recent": "新着",
    "templates": "テンプレートコミュニティ",
    "all": "すべてのカテゴリ",
    "recommend": "おすすめのカテゴリー",
    "home": "ホーム",
    "tag": "タグ"
  },
  "pt": {
    "theEnd": "Inferior",
    "noResult": "Sem Resultados",
    "trending": "Tendendo",
    "recent": "Recente",
    "templates": "Comunidade de Modelos",
    "all": "Todas as coleções",
    "recommend": "Categoria recomendada",
    "home": "Início",
    "tag": "Marcação"
  },
  "it": {
    "theEnd": "Basso",
    "noResult": "Nessun Risultato",
    "trending": "Tendenza",
    "recent": "Recente",
    "templates": "Comunità di Modelli",
    "all": "Tutte le Collezioni",
    "recommend": "Categoria consigliata",
    "home": "Casa",
    "tag": "Etichetta"
  },
  "tw": {
    "theEnd": "到底了",
    "noResult": "未搜尋到",
    "trending": "趨勢",
    "recent": "最近",
    "templates": "範本社區",
    "all": "所有類別",
    "recommend": "推薦類別",
    "home": "轉到主頁",
    "tag": "標籤"
  },
  "kr": {
    "theEnd": "끝입니다~",
    "noResult": "결과 없음",
    "trending": "인기 순",
    "recent": "신규 순",
    "templates": "템플릿 갤러리",
    "all": "모든 컬랙션",
    "recommend": "추천 카테고리",
    "home": "메인 화면 가기",
    "tag": "꼬리표"
  },
  "id": {
    "theEnd": "Bawah",
    "noResult": "Tidak Ada Hasil",
    "trending": "Sedang Tren",
    "recent": "Terbaru",
    "templates": "Komunitas Templat",
    "all": "Semua Koleksi",
    "recommend": "Koleksi Rekomendasi",
    "home": "Beranda",
    "tag": "tag"
  }
}
</i18n>
